$(document).ready(function(){
    let owl = $('.owl-tabs');
    let url = document.location.toString();

    owl.owlCarousel({
        items:4,
        dots:false,
        loop:true,
        stopOnHover : true,
        autoHeight: false,
        nav: true,
        mouseDrag: false,
        touchDrag: false,
        navText: ["",""],
        responsive:{
          0 : {
            items: 1
          },
          768: {
            items: 2
          },
          992: {
            items: 3
          },
          1200:{
            items: 4
          }
        }
    });

      // Javascript to enable link to tab    
    if (url.match('#')) {
        $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
        setTimeout(function(){
          $('.owl-item .nav-link').removeClass('active');
          $('a[href="#' + url.split('#')[1] + '"]').addClass('active');
        },1000)
    } 

    //Change hash for page-reload
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
       
        window.location.hash = e.target.hash;
        // $('.owl-item .nav-link').removeClass('active');
        // $(e.target).addClass('active');

        // $('html, body').animate({
        //   scrollTop: $(e.target.hash+'-tab').offset().top
        // }, 500);
    })

    //add sticky classs
    let tabHeight = $('#top').height();   
    $(window).scroll(function() {
      if($(window).scrollTop() > tabHeight - 72) {
        $('#main-tabs').addClass('sticky');
      } else {
        $('#main-tabs').removeClass('sticky');
      }
    });
  });